import styled from 'styled-components';

const NoDataWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 10;
`;

/**
 * Displays a "No data to show" message, centered in its parent.
 * Parent MUST have `position: relative` for proper positioning.
 */
export const NoData = () => (
    <NoDataWrapper>
        <strong>No data to show</strong>
    </NoDataWrapper>
);
